import React, { useEffect, useRef } from "react";
import Hls from "hls.js";

export default function Video({ data }) {
    const videoRef = useRef(null);
    const lastTime = useRef(0);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const url = data;

        let hls;

        if (Hls.isSupported()) {
            hls = new Hls();
            hls.loadSource(url);
            hls.attachMedia(video);

            hls.on(Hls.Events.MANIFEST_PARSED, () => {
                video.play().catch(() => { });
            });
        } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
            video.src = url;
        }

        const handleTimeUpdate = () => {
            lastTime.current = video.currentTime;
        };

        const handleSeeking = () => {
            if (Math.abs(video.currentTime - lastTime.current) > 0.5) {
                video.currentTime = lastTime.current;
            }
        };

        video.addEventListener("timeupdate", handleTimeUpdate);
        video.addEventListener("seeking", handleSeeking);

        return () => {
            video.removeEventListener("timeupdate", handleTimeUpdate);
            video.removeEventListener("seeking", handleSeeking);

            if (hls) hls.destroy();
        };
    }, [data]);

    return (
        <>
            <br /><br /><br /> 

            <div className="video">
                <video
                    ref={videoRef}
                    controls
                    autoPlay
                    playsInline
                    disablePictureInPicture
                    controlsList="nodownload noplaybackrate"
                    onContextMenu={(e) => e.preventDefault()}
                />
            </div>
        </>
    );
}